import React, { useCallback } from 'react'
import Particles from 'react-tsparticles'
import { loadLinksPreset } from 'tsparticles-preset-links'
import Container from '../components/Container'
import Footer from '../components/Footer/Footer'
import OurPeople from '../components/OurPeople'
import OurStory from '../components/OurStory'
import OurValues from '../components/OurValues'
import PressReleases from '../components/PressReleases'
import Recognition from '../components/Recognition'
import { PageProps } from 'gatsby'
import { lighten } from 'polished'
import { SEO } from '../SEO'
import { Site } from '../components/Site'

import styled, { keyframes } from 'styled-components'
import Board from '../components/Board/Board'
import Security from '../components/Security/Security'
import { Main } from '../components/Styled'

export default (props: PageProps) => {
  const particlesInit = useCallback(async engine => {
    await loadLinksPreset(engine)
  }, [])

  const particlesLoaded = useCallback(async container => {
    await console.log(container)
  }, [])

  return (
    <Site seo={SEO.about} {...props}>
      <Main>
        <LandingPageBanner>
          <H1Wrapper>
            <Container>
              <div style={{ position: 'relative' }}>
                {/** @ts-ignore */}
                <Particles
                  id='tsparticles'
                  init={particlesInit}
                  loaded={particlesLoaded}
                  options={{
                    preset: 'links',
                    style: { position: 'absolute', top: '0', height: '100%', left: '0', width: '100%' },
                    background: { color: 'transparent' },
                    particles: { move: { speed: 1 }, number: { value: 25 } },
                    interactivity: {
                      detectsOn: 'canvas',
                      events: {
                        onClick: {
                          enable: true,
                          mode: 'push',
                        },
                        onHover: {
                          enable: false,
                        },
                        resize: true,
                      },
                    },
                  }}
                />
                <LogoWrapper>
                  <svg data-name='Layer 1' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 205.04 69.54'>
                    <path
                      d='M93.38 69.54H43.56a2.79 2.79 0 01-2.66-2.76 2.72 2.72 0 012.66-2.77h49.82a2.72 2.72 0 012.66 2.75 2.79 2.79 0 01-2.66 2.78z'
                      fill='#4fb861'
                    />
                    <path
                      fill='#fff'
                      d='M36.98 49.63a2.76 2.76 0 01-5.52 0v-5c-3 4.39-7.26 8.17-14 8.17-8.79 0-17.49-7-17.49-19v-.1c0-12 8.7-19 17.49-19 6.76 0 11.15 3.68 14 7.76V2.86A2.62 2.62 0 0133.98.11a1.31 1.31 0 01.28 0 2.68 2.68 0 012.72 2.6v46.92zm-31.5-16v.2c0 8.58 6 14.09 13 14.09 6.74 0 13.17-5.74 13.17-14.12v-.2c0-8.37-6.44-14-13.19-14-7.15 0-13 5.22-13 14zM43.68 41.36v-.09c0-7.66 6.45-11.85 15.76-11.85a38.89 38.89 0 0111.24 1.59v-1.29c0-6.54-4.09-9.91-11-9.91a22.45 22.45 0 00-9.51 2.05 3.78 3.78 0 01-1 .2 2.39 2.39 0 01-.92-4.59 29.82 29.82 0 0112.12-2.46c5.11 0 9.1 1.32 11.76 4 2.56 2.45 3.79 6 3.79 10.62v20a2.59 2.59 0 01-2.41 2.75h-.15a2.5 2.5 0 01-2.67-2.31 2.26 2.26 0 010-.26v-3.34a16.11 16.11 0 01-13.3 6.33c-6.77 0-13.71-3.89-13.71-11.44zm27.11-2.76v-3.59a37.52 37.52 0 00-10.81-1.51c-6.86 0-10.74 3-10.74 7.55v.1c0 4.6 4.29 7.36 9.31 7.36 6.63 0 12.25-4.19 12.25-9.91zM98.8 48.1a2.31 2.31 0 01-1-1.94 2.39 2.39 0 012.45-2.35 1.87 1.87 0 011.33.41 20.75 20.75 0 0011.67 3.88c4.39 0 7.57-2.25 7.57-5.82v-.1c0-3.68-4.3-5.11-9.21-6.44-5.73-1.63-12.07-3.57-12.07-10.31v-.1c0-6.32 5.21-10.52 12.44-10.52a25.08 25.08 0 0111.7 3.2 2.58 2.58 0 011.41 2.29 2.45 2.45 0 01-2.41 2.3 3.48 3.48 0 01-1.23-.31 20.16 20.16 0 00-9.47-2.88c-4.39 0-7.16 2.24-7.16 5.31v.1c0 3.47 4.61 4.8 9.42 6.33 5.72 1.73 11.86 3.88 11.86 10.41v.21c0 6.94-5.83 10.92-13.09 10.92A25.22 25.22 0 0198.8 48.1zM149.44 52.8c-10.13 0-18.31-7.66-18.31-19v-.1c0-10.52 7.47-19 17.59-19 10.84 0 17.09 8.78 17.09 18.48a2.53 2.53 0 01-2.51 2.55h-26.62c.82 7.87 6.45 12.36 12.89 12.36a15.18 15.18 0 0010.63-4.19 2.19 2.19 0 011.55-.71 2.47 2.47 0 012.45 2.35 2.14 2.14 0 01-.93 1.73 18.45 18.45 0 01-13.83 5.53zm10.84-21c-.51-6.68-4.4-12.53-11.66-12.53-6.45 0-11.25 5.31-12 12.46zM188.68 52.8c-10 0-18.32-7.66-18.32-19v-.1c0-10.52 7.48-19 17.61-19 10.84 0 17.07 8.78 17.07 18.48a2.53 2.53 0 01-2.51 2.55h-26.55c.82 7.87 6.44 12.36 13 12.36a15 15 0 0010.54-4.19 2.16 2.16 0 011.53-.71 2.46 2.46 0 012.45 2.35 2.14 2.14 0 01-.91 1.73 18.48 18.48 0 01-13.91 5.53zm10.84-21c-.47-6.68-4.35-12.53-11.62-12.53-6.44 0-11.25 5.31-12 12.46zM85.09 50.34V16.65a2.77 2.77 0 015.53 0v33.69a2.77 2.77 0 01-5.53 0z'
                    />
                    <path d='M84.58 3.17a3.17 3.17 0 113.17 3.17 3.17 3.17 0 01-3.17-3.17z' fill='#fff' />
                  </svg>
                </LogoWrapper>

                <Content>
                  <Grid>
                  </Grid>
                  <H1>We are daisee</H1>
                  <H2>
                    We are an Australian AI provider supporting leading contact centres with the power to mine and use
                    insights from customer conversations to drive better compliance, efficiency and satisfaction
                    outcomes.
                    <br />
                    <br />
                    We believe your customers are already telling you what they want. With the right combination of AI,
                    machine learning and behavioural science, you can draw out rich lessons to understand the topics
                    customers are calling about and predict business outcomes.
                  </H2>
                  <MouseWrapper>
                    <Mouse>
                      <MouseMovement />
                    </Mouse>
                    <MouseMessage>scroll</MouseMessage>
                  </MouseWrapper>
                </Content>
              </div>
            </Container>
          </H1Wrapper>
        </LandingPageBanner>
        <OurStory />
        <Security />
        <Recognition />
        <OurPeople />
        <Board />
        <OurValues />
        <PressReleases />
      </Main>

      <Footer />
    </Site>
  )
}

const Grid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  justify-content: center;
  margin: 0 auto; 
  max-width: 45em;
  
  @media (max-width: 48em) {
    grid-template-columns: 1fr;
    gap: 2rem;
  }
`

const LandingPageBanner = styled.section`
  margin-top: 6rem;
  background: ${({ theme }) =>
    `linear-gradient(101deg,${lighten(0.2, theme.colors.purple)} 0%, ${theme.colors.purple} 100%)`};
  min-height: 40vh;
`

const H1 = styled.h1`
  margin: 0;
  font-weight: 500;
  font-size: 5vw;
  letter-spacing: -1px;
  line-height: 1.1;
  color: #fff;
  text-align: center;
  padding-bottom: 3rem;
  padding-top: 6rem;
  @media all and (max-width: 48em) {
    font-size: 2rem;
  }
`

const H1Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  padding: 0 1.5rem;
`

const H2 = styled.h2`
  margin: 0;
  font-weight: 400;
  font-size: 1.5vw;
  max-width: 50ch;
  text-align: center;
  line-height: 1.7;
  color: #fff;
  text-align: center;
  margin: 0 auto;

  @media all and (max-width: 48em) {
    font-size: 1rem;
  }
`

const Content = styled.div`
  padding: 6rem 0;
  transition: all 0.75s ease;
  position: relative;
  height: fit-content;
`

const ScrollAnimation = keyframes`
0% {
    opacity: 1;
    top: 29%;
  }
  15% {
    opacity: 1;
    top: 50%;
  }
  50% {
    opacity: 0;
    top: 50%;
  }
  100% {
    opacity: 0;
    top: 29%;
  }
`

const LogoWrapper = styled.div`
  max-width: 350px;
  margin: 0 auto;
  padding: 6rem 0 1.5rem;
`

const MouseWrapper = styled.div`
  line-height: 18px;
  font-size: 13px;
  font-weight: normal;
  color: #7f8c8d;
  color: #fff;
  letter-spacing: 2px;
  margin-top: 10%;
  text-decoration: none;
  overflow: hidden;
  margin: 0 auto;
  text-align: center;
  padding-top: 3rem;
`

const Mouse = styled.span`
  position: relative;
  display: block;
  width: 24px;
  height: 43px;
  margin: 0 auto 20px;
  border: 2px solid #fff;
  border-radius: 23px;
`

const MouseMovement = styled.span`
  position: absolute;
  display: block;
  top: 29%;
  left: 60%;
  width: 4px;
  height: 4px;
  margin: -4px 0 0 -4px;
  background: #fff;
  border-radius: 50%;
  animation: ${ScrollAnimation} 4s linear infinite;
`

const MouseMessage = styled.span`
  padding: 0;
  animation: ${ScrollAnimation} 4s linear infinite;
  display: block;
  text-align: center;
`
